// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"15ed8919","129":"1e11f479","197":"731af2e7","321":"fbc0abcd","618":"ff5aa6c1"}[chunkId] + ".chunk.js";
};